"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _api = require("../api");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'SelectStaff',
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      tableData: {
        total: 0
      },
      pageFrom: {
        page: 1,
        limit: 15,
        customerId: null,
        status: 1,
        customerIntegralId: null,
        empName: '',
        phone: '',
        workUnit: ''
      },
      selList: _toConsumableArray(this.list)
    };
  },
  watch: {
    // 当父组件传入的已选列表变化时，同步到内部 selList（用于跨页保留及回显）
    list: {
      handler: function handler(val) {
        this.selList = Array.isArray(val) ? _toConsumableArray(val) : [];
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    open: function open(id, integralId) {
      this.pageFrom.customerId = id;
      this.pageFrom.customerIntegralId = integralId;
      this.getInfo();
      this.dialogFormVisible = true;
    },
    close: function close() {
      this.dialogFormVisible = false;
    },
    show: function show(list) {
      var _this = this;
      this.$refs.tableRef.clearSelection();
      var ids = this.tableData.list.map(function (item) {
        return item.id;
      });
      this.$nextTick(function () {
        list.forEach(function (item) {
          var index = ids.indexOf(item.id);
          if (index > -1) {
            _this.$refs.tableRef.toggleRowSelection(_this.tableData.list[index], true);
          }
        });
      });
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pageFrom.limit = size;
      this.getInfo();
    },
    pageChange: function pageChange(page) {
      this.pageFrom.page = page;
      this.getInfo();
    },
    // 查询按钮 - 重置页码后再查询
    handleSearch: function handleSearch() {
      this.pageFrom.page = 1;
      this.getInfo();
    },
    // 重置按钮 - 清空搜索条件并重置页码后再查询
    handleReset: function handleReset() {
      this.pageFrom.empName = '';
      this.pageFrom.phone = '';
      this.pageFrom.workUnit = '';
      this.pageFrom.page = 1;
      this.getInfo();
    },
    getInfo: function () {
      var _getInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              // 开启加载动画
              this.loading = true;
              _context.p = 1;
              _context.n = 2;
              return (0, _api.empListApi)(this.pageFrom);
            case 2:
              res = _context.v;
              this.tableData = res;
              if (this.selList.length > 0) {
                this.show(this.selList);
              }
              // this.pageFrom.page = 1;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this.$message.error(_t.message);
            case 4:
              _context.p = 4;
              // 关闭加载动画
              this.loading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function getInfo() {
        return _getInfo.apply(this, arguments);
      }
      return getInfo;
    }(),
    handleSelectionChange: function handleSelectionChange(list) {
      // 合并跨页选择：保留其他页已选，更新本页选中
      var currentIds = this.tableData.list.map(function (item) {
        return item.id;
      });
      // 先保留非本页已选项
      var remain = this.selList.filter(function (item) {
        return !currentIds.includes(item.id);
      });
      // 合并当前页选中项（去重）
      list.forEach(function (item) {
        if (!remain.some(function (sel) {
          return sel.id === item.id;
        })) {
          remain.push(item);
        }
      });
      this.selList = remain;
    },
    submit: function submit() {
      this.$emit('update', this.selList);
      console.log('this.selList>>>>>>>>>>>>>>>>>>>', this.selList);
      this.pageFrom = {
        page: 1,
        limit: 15,
        customerId: null,
        status: 1,
        customerIntegralId: null,
        empName: '',
        phone: '',
        workUnit: ''
      }, this.close();
    }
  }
};